export const GLOBAL_SEO_LOCKED_RULES = [
  {
    pattern: /^\/p(\/.*)?$/,
    type: "private_dashboard",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/agent(\/.*)?$/,
    type: "private_agent",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/admin(\/.*)?$/,
    type: "admin",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/dashboard(\/.*)?$/,
    type: "dashboard",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/crm(\/.*)?$/,
    type: "crm",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/leads(\/.*)?$/,
    type: "leads",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/checkout(\/.*)?$/,
    type: "checkout",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/payment(\/.*)?$/,
    type: "payment",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/api(\/.*)?$/,
    type: "api",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/auth(\/.*)?$/,
    type: "auth",
    locked: true,
    index: false,
    follow: false,
    sitemap: false,
    disallow: true,
    allowAgentOverride: false,
  },
];

export const SEO_TEMPLATE_RULES = [
  {
    pattern: /^\/$/,
    type: "home",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/blog(\/.*)?$/,
    type: "blog",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/destinations(\/.*)?$/,
    type: "destination",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/packages(\/.*)?$/,
    type: "package",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/hotels(\/.*)?$/,
    type: "hotel",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/search(\/.*)?$/,
    type: "dynamic_search",
    index: false,
    follow: true,
    sitemap: false,
    disallow: false,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/vacation-packages(\/.*)?$/,
    type: "vacation_packages",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/attractions(\/.*)?$/,
    type: "attractions",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/packages\/profile(\/.*)?$/,
    type: "package_profile",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/hotelprofile(\/.*)?$/,
    type: "hotel_profile",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/tour\/profile(\/.*)?$/,
    type: "tour_profile",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/contact$/,
    type: "contact",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/termsAndConditions$/,
    type: "terms",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/agentTerms$/,
    type: "agent_terms",
    index: true,
    follow: true,
    sitemap: true,
    disallow: false,
    allowAgentOverride: true,
  },
  {
    pattern: /^\/offers\/public(\/.*)?$/,
    type: "public_offer_link",
    index: false,
    follow: true,
    sitemap: false,
    disallow: false,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/customer-chat(\/.*)?$/,
    type: "customer_chat",
    index: false,
    follow: true,
    sitemap: false,
    disallow: false,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/login$/,
    type: "login",
    index: false,
    follow: true,
    sitemap: false,
    disallow: false,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/registeragent(\/.*)?$/,
    type: "register_agent",
    index: false,
    follow: true,
    sitemap: false,
    disallow: false,
    allowAgentOverride: false,
  },
  {
    pattern: /^\/flights(\/.*)?$/,
    type: "flights_flow",
    index: false,
    follow: true,
    sitemap: false,
    disallow: false,
    allowAgentOverride: false,
  },
];

export const DEFAULT_UNKNOWN_SEO_RULE = {
  type: "unknown",
  locked: false,
  index: false,
  follow: true,
  sitemap: false,
  disallow: false,
  allowAgentOverride: false,
};
